const removeTTWaterMark = {
  HitPawTikTokTitle: 'إزالة علامة التيك توك أون لاين HitPaw',
  ExportVideoWithoutWaterMark: 'تصدير الفيديو بدون علامة HitPaw',
  ProcessTiktokLinkWithoutLimits: 'تصدير الفيديو بدون العلامة المائية HitPaw',
  FasterProcessingSpeed: '10 أضعاف سرعة المعالجة',
  PrioritySupport: 'دعم الأولوية',
  DiscountPrice: '$0.99',
  WeekTotalPrice: '$4.49',

  MonthWeekPrice: '$1.75',
  MonthTotalPrice: '$6.99',

  YearWeekPrice: '$0.87',
  YearTotalPrice: '$41.88',
  Day: 'Day',
  Weekly: 'أسبوعي',
  Monthly: 'شهري',
  Yearly: 'سنوي',
  week: 'أسبوع',
};

export default removeTTWaterMark;
